import React from 'react';

const CategoryProgressCard = ({ category }) => {
  const progress = (category.collected / category.total) * 100;

  return (
    <div className="relative flex-shrink-0 w-48 h-32 rounded-xl overflow-hidden shadow-md border border-gray-100 snap-start group cursor-pointer">
      {/* Background Image */}
      <img 
        src={category.image} 
        alt={category.name}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
      />
      
      {/* Dark Overlay for readability */}
      <div className="absolute inset-0 bg-black/50 group-hover:bg-black/40 transition-colors duration-300" />

      {/* Content */}
      <div className="absolute inset-0 p-4 flex flex-col justify-end text-white">
        <h4 className="font-bold text-lg mb-2 shadow-black drop-shadow-md">{category.name}</h4>
        
        <div className="w-full mb-1">
          <div className="w-full h-2 bg-white/30 rounded-full overflow-hidden backdrop-blur-sm">
            <div 
              className="h-full bg-green-400 rounded-full shadow-[0_0_8px_rgba(74,222,128,0.6)]"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
        
        <span className="text-xs font-medium text-gray-100 drop-shadow-md">
          {category.collected} / {category.total} hittade
        </span>
      </div>
    </div>
  );
};

export default CategoryProgressCard;
